// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c746853d","38":"ff65133f","777":"2e26cf15"}[chunkId] + ".chunk.js";
};